import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {ToastContainer, ToastStore} from 'react-toasts';
import _ from "underscore";
import $ from "jquery";
import moment from 'moment';

class ToolBar extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {
        //buttons: ["Text Input", "DropDown", "Check Box", "Paragraph"],
        buttons: {
                  "Text": {
                    value: "",//Value for "fill" mode
                    text: "Text!",
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    fontSize: 20,
                    paddingLeft: 10,
                    paddingRight: 10,
                    fontColor: "black",
                    textAlign: "center",
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "text",
                    parentElement: null,
                  },
                  "Text Input": {
                    value: "",//Value for "fill" mode
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    label: "Label Here!",
                    id: "TextInput_"+new Date().getTime(),
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "textInput",
                    parentElement: null,
                  },
                  "Text Area": {
                    value: "",//Value for "fill" mode
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    label: "Label Here!",
                    lines: {value: 4,
                                toolTip: "Number of lines the Text Area shows at a time."},
                    id: "TextArea_"+new Date().getTime(),
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "textArea",
                    parentElement: null,
                  },
                  "Date Field": {
                    value: "",//Value for "fill" mode
                    dateFormat: {value: "MM/DD/YYYY",
                                  toolTip: "Only supports 'MM', 'DD' and 'YYYY'. Supports separators: ',', '-', and '/'."},
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    label: "Label Here!",
                    id: "DateField_"+new Date().getTime(),
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "dateField",
                    parentElement: null,
                  },
                  "File Upload Field": {
                    value: "",//Value for "fill" mode
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    label: "Label Here!",
                    id: "FileUpload_"+new Date().getTime(),
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "fileUpload",
                    parentElement: null,
                  },
                  "Button": {
                    className:{value: "col-md-2",
                                toolTip: "Used for setting styles for button's wrapper, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    btnClassName:{value: "col-md-12",
                                toolTip: "Used for setting styles for the button itself, most notably, colors and design. Based on BootStrap"},
                    text: "Button",
                    id: "button_"+new Date().getTime(),
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    type: "button",
                    buttonType: {
                      editorLabel: "Type",
                      editorFieldType: "dropDown",
                      list: ["Submit", "Repeat"],
                      value: "Submit",
                    },
                    parentElement: null,
                    groupToRepeat: {value: "None",
                                  toolTip: "Group to Repeat. On Fill mode, pressing this button should add an iteration of the Group's members to the form. In Progress"},//Should only appear if buttonType.value == Repeat
                  },
                  "Select": {
                    value: "",//Value for "fill" mode
                    className:{value: "col-md-12",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap"},
                    label: "Label Here!",
                    id: "Select_"+new Date().getTime(),
                    buttonType: {
                      editorLabel: "Type",
                      editorFieldType: "dropDown",
                      list: ["Default", "Client"],
                      value: "Default",
                      specialType: "dropDownChoice",//For special types, like in dropDown Choices
                    },
                    choices: {value: [],
                              newChoice: "",
                              editorFieldType: "list",
                              toolTip: "List of items to choose from in the Select field."},
                    type: "select",
                    parentElement: null,
                  },
                  "Column": {
                    children: [],//Value for "fill" mode
                    className:{value: "col-md-6",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap. Gets overridden by width if width is not empty."},
                    type: "column",
                    height: {value: 250,
                              toolTip: "Used for column height. If set to 'max', height will be equal to screen height. Otherwise, value is in pixels."},
                    width: {value: 1,
                              toolTip: "Used for column width, inside it's style{}. Value should be a decimal between 0 and 1, with 1 being equal to this element's parent's width. If there is no parent, then the width of the Form Builder's Canvas will be the basis. Overrides className width."},
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    parentElement: null,
                    isClone: false,
                  },
                  "Container": {
                    children: [],//Value for "fill" mode
                    className:{value: "col-md-6",
                                toolTip: "Used for setting styles, most notably, widths. Screen/container is divided into 12, so 6 means half-width, 4 means a third, etc. Based on BootStrap. Gets overridden by width if width is not empty."},
                    type: "container",
                    height: {value: 250,
                              toolTip: "Used for column height. If set to 'max', height will be equal to screen height. Otherwise, value is in pixels."},
                    width: {value: 1,
                              toolTip: "Used for column width, inside it's style{}. Value should be a decimal between 0 and 1, with 1 being equal to this element's parent's width. If there is no parent, then the width of the Form Builder's Canvas will be the basis. Overrides className width."},
                    cloneGroup: {value: "None",
                                  toolTip: "For Repeat buttons. A repeat Button has a Clone Group it can repeat."},//For Repeat Button functionality
                    parentElement: null,
                    isClone: false,
                  }
        }
      }
  }

  render() {
    var buttons = this.state.buttons;
    return <Row>
              <Col>
                {Object.keys(buttons).map((button, index)=>{
                  return <Row key={index} style={{paddingBottom: 10}}>
                            <Button style={{width: "100%"}} onClick={()=>{this.addElement(buttons[button])}}>{button}</Button>
                          </Row>
                })}
              </Col>
            </Row>;
  }

  addElement(element) {
    var newElement = JSON.parse(JSON.stringify(element))
    newElement.id = element.type+"_"+new Date().getTime();
    this.props.addElement(newElement);
  }


}

export default ToolBar;
